import { render, staticRenderFns } from "./TencentViewer.vue?vue&type=template&id=2aeb45b1"
import script from "./TencentViewer.vue?vue&type=script&lang=js"
export * from "./TencentViewer.vue?vue&type=script&lang=js"
import style0 from "./TencentViewer.vue?vue&type=style&index=0&id=2aeb45b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports